import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { brand, services } from '../mock/mockData';

export default function Footer() {
  return (
    <footer className="bg-forest-950 text-cream-100 border-t border-forest-800">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="font-serif text-cream-50 text-xl md:text-2xl tracking-[0.06em] leading-[0.98] font-semibold">
            <div>PERRIN</div>
            <div>MYDDELTON</div>
          </div>
          <p className="mt-2 text-[10px] tracking-[0.18em] uppercase text-cream-100/55">A trading name of Hedges Law</p>
          <p className="mt-5 text-sm text-cream-100/70 leading-relaxed max-w-xs">Trusted Solicitors in Harpenden. Delivering Expertise with Care to clients for over 20 years.</p>
        </div>

        <div>
          <h4 className="text-cream-50 text-lg mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {services.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-cream-100/75 hover:text-sage-400 transition-colors">{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-cream-50 text-lg mb-4">The Firm</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-cream-100/75 hover:text-sage-400 transition-colors">About Us</Link></li>
            <li><Link to="/our-people" className="text-cream-100/75 hover:text-sage-400 transition-colors">Our People</Link></li>
            <li><Link to="/case-studies" className="text-cream-100/75 hover:text-sage-400 transition-colors">Case Studies</Link></li>
            <li><Link to="/pricing" className="text-cream-100/75 hover:text-sage-400 transition-colors">Pricing</Link></li>
            <li><Link to="/insights" className="text-cream-100/75 hover:text-sage-400 transition-colors">Insights</Link></li>
            <li><Link to="/careers" className="text-cream-100/75 hover:text-sage-400 transition-colors">Careers</Link></li>
            <li><Link to="/contact" className="text-cream-100/75 hover:text-sage-400 transition-colors">Contact Us</Link></li>
            <li><a href="https://hedgeslaw.co.uk/privacy/" target="_blank" rel="noopener noreferrer" className="text-cream-100/75 hover:text-sage-400 transition-colors">Privacy Policy</a></li>
            <li><Link to="/complaints" className="text-cream-100/75 hover:text-sage-400 transition-colors">Complaints</Link></li>
            <li><a href="https://hedgeslaw.co.uk/terms/" target="_blank" rel="noopener noreferrer" className="text-cream-100/75 hover:text-sage-400 transition-colors">Terms of Business</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-cream-50 text-lg mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm text-cream-100/75">
            <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 text-sage-400 flex-shrink-0" /><span>{brand.address.line1}<br />{brand.address.line2}<br />{brand.address.city}, {brand.address.postcode}</span></li>
            <li className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 text-sage-400" /><a href={`tel:${brand.phone.replace(/\s/g,'')}`} className="hover:text-sage-400">{brand.phone}</a></li>
            <li className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 text-sage-400" /><a href="mailto:hello@hedgeslaw.co.uk" className="hover:text-sage-400 break-all">hello@hedgeslaw.co.uk</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-forest-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <p className="text-xs text-cream-100/50 text-center md:text-left flex-1 order-2 md:order-1">© {new Date().getFullYear()} Perrin Myddelton, a trading name of Hedges Law. Authorised and regulated by the Solicitors Regulation Authority (SRA). SRA ID: 552980. Company Number: 7428900.</p>
          <div
            className="w-[180px] md:w-[200px] mx-auto md:mx-0 order-1 md:order-2 flex-shrink-0"
            data-testid="sra-digital-badge"
            aria-label="SRA Digital Badge"
          >
            <div style={{ position: 'relative', paddingBottom: '59.1%', height: 'auto', overflow: 'hidden' }}>
              <iframe
                title="SRA Digital Badge"
                frameBorder="0"
                scrolling="no"
                allowTransparency="true"
                src="https://cdn.yoshki.com/iframe/55849r.html"
                style={{ border: 0, margin: 0, padding: 0, backgroundColor: 'transparent', top: 0, left: 0, width: '100%', height: '100%', position: 'absolute' }}
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
